import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { deleteAppointment } from '../../api/appointments';
import {
  setAppointmentIdToEdit,
  setAppointmentsList
} from '../../store/appointmentsSlice';
import { RootState } from '../../store/store';
import Modal from '../BaseComponents/Modal';
import Button from '../BaseComponents/Button';
import './Appointments.scss';

type IProps = {
  isOpen: boolean;
  onClose: () => void;
  onAppointmentsChanged?: () => void;
};

export interface FormValues {
  clinic: { key: any; value: string };
  meeting_link: string | null | undefined;
  time: any;
  tests: { key: any; value: any }[];
  title: string;
  preparation_text: string;
}

const DeleteAppointmentModal = ({
  isOpen,
  onClose,
  onAppointmentsChanged
}: IProps) => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const { appointmentIdToEdit, appointmentsList } = useSelector(
    (state: RootState) => state.appointments
  );
  const onCloseClick = () => {
    dispatch(setAppointmentIdToEdit(null));
    setError(false);
    onClose();
  };

  const onDeleteClick = async () => {
    setIsLoading(true);
    try {
      await deleteAppointment(appointmentIdToEdit!);
      const updatedAppointmentsList = appointmentsList.filter(
        (appointment) => appointment.id !== appointmentIdToEdit
      );
      dispatch(setAppointmentsList(updatedAppointmentsList));
      onAppointmentsChanged?.();
      onCloseClick();
    } catch (error: any) {
      console.log('error :>> ', error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onCloseClick} width={'400px'}>
      <div className='delete-appointment-container'>
        <div className='modal-header'>
          <div>Are you sure you want to delete appointment?</div>
        </div>

        <div className='submit-btn-wrapper'>
          <Button text='Delete' onClick={onDeleteClick} isLoading={isLoading} />
          <Button
            text='Cancel'
            onClick={onCloseClick}
            backgroundColor={'#ffffff'}
            color={'#2D334E'}
          />
          {error && (
            <div className='err-message'>
              {typeof error === 'boolean'
                ? 'Something went wrong, please try again.'
                : error}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default DeleteAppointmentModal;
